import React from 'react';
import { SimpleGrid } from '@wegroup/design-system';
import { Offer } from '../../../../../../../../types/Offer';
import { useAffiliations } from '../../../../../../../common/src/api/getAffiliations';
import PrefillOfferModalOffersCard from './PrefillOfferModalOffersCard';

interface Props {
  offers: Offer[];
  onSelect: (offer: Offer) => void;
}

const PrefillOfferModalOffers: React.FC<Props> = ({ offers, onSelect }) => {
  /** To get show extra affiliation data, we retrieve it from the affiliation api */
  const { data: affiliations } = useAffiliations();

  return (
    <SimpleGrid columns={2} gridGap="4">
      {offers.map((offer) => {
        const insuranceInfo = affiliations?.items.find(
          ({ name }) => name === offer.insurance?.company,
        );
        return (
          <PrefillOfferModalOffersCard
            key={offer.id}
            offer={offer}
            label={insuranceInfo?.label}
            logo={insuranceInfo?.logo}
            onSelect={onSelect}
          />
        );
      })}
    </SimpleGrid>
  );
};

export default PrefillOfferModalOffers;
